<section
  *transloco="let t"
  class="relative isolate mt-1 mb-12 overflow-hidden rounded-2xl bg-slate-900 sm:mt-2 sm:mb-16 sm:rounded-3xl"
>
  <!-- Hero Image -->
  <img
    src="/assets/images/home/covers/cover-first-page.webp"
    alt=""
    width="2400"
    height="1372"
    fetchpriority="high"
    class="absolute inset-0 -z-10 h-full w-full object-cover"
  />
  <div class="absolute inset-0 -z-10 bg-slate-950/35"></div>

  <!-- Hero Content -->
  <div
    class="mx-auto flex min-h-[58vh] max-w-5xl flex-col items-center justify-center px-5 py-14 text-center sm:min-h-[80vh] sm:px-6 sm:py-28"
  >
    <!-- Title -->
    <h1
      class="text-4xl font-extrabold leading-tight tracking-tight text-white drop-shadow-md sm:text-5xl md:text-6xl lg:text-7xl"
    >
      {{ t('home.hero.title') }}
    </h1>

    <!-- Subtitle -->
    <p
      class="mt-4 max-w-2xl text-base font-medium text-white/90 drop-shadow sm:mt-5 sm:text-xl lg:text-2xl"
    >
      {{ t('home.hero.subtitle') }}
    </p>

    <!-- Call to Action -->
    <button appButton size="lg" type="button" class="mt-8 sm:mt-9" (click)="ctaClick.emit()">
      {{ t('home.hero.cta') }}
    </button>
  </div>
</section>
